import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useRouter } from 'vue-router';
import ProgressSpinner from 'primevue/progressspinner';
import { useCalculatorsStore } from '../store/calculators';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorSelectView',
  setup(__props) {

const calculatorsStore = useCalculatorsStore();
const router = useRouter();

watch(
  () => calculatorsStore.data,
  (newValue) => {
    if (calculatorsStore.data) {
      router.push({
        name: 'HomeView',
        params: { calculatorId: calculatorsStore.data[0].id },
      });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ProgressSpinner))
  ]))
}
}

})